import { useState, useEffect, useCallback } from "react";

interface ToastMessage {
  id: number;
  text: string;
  type: "success" | "warning" | "info";
}

let toastId = 0;
let addToastFn: ((text: string, type: ToastMessage["type"]) => void) | null = null;

export function showToast(text: string, type: ToastMessage["type"] = "info") {
  addToastFn?.(text, type);
}

export function ToastContainer() {
  const [toasts, setToasts] = useState<ToastMessage[]>([]);

  const addToast = useCallback((text: string, type: ToastMessage["type"]) => {
    const id = ++toastId;
    setToasts(prev => [...prev, { id, text, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3000);
  }, []);

  useEffect(() => {
    addToastFn = addToast;
    return () => { addToastFn = null; };
  }, [addToast]);

  const colors = {
    success: "bg-green-600 border-green-400",
    warning: "bg-yellow-600 border-yellow-400",
    info: "bg-blue-600 border-blue-400",
  };

  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-2">
      {toasts.map(t => (
        <div
          key={t.id}
          className={`${colors[t.type]} border text-white px-4 py-2 rounded-lg shadow-lg font-pokemon text-xs animate-slide-up`}
        >
          {t.text}
        </div>
      ))}
    </div>
  );
}
